import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
    {path: '/login', component: () => import('@/views/login/index'), hidden: true},
    {path: '/404', component: () => import('@/views/404'), hidden: true},
    // {path: '/401', component: () => import('@/views/err/401'), hidden: true},
    {
        //支持第三方iframe网站
        path: '/iframe',
        component: Layout,
        redirect: '/iframe', // you can set roles in root nav
        children: [{
            path: 'iframe',
            name: 'iframe',
            component: () => import('@/views/iframe/index'),
            meta: {
                title: '第三方iframe',
                icon: 'people'
            }
        }],
        hidden: true
    },
    {
        //401没有权限
        path: '/err',
        component: Layout,
        children: [{
            path: '401',
            name: '401',
            component: () => import('@/views/err/401'),
            meta: {
                title: '没有权限',
                icon: ''
            }
        }],
        hidden: true
    },
    {
        path: '',
        component: Layout,
        redirect: '/home',
        children: [
            {
                //首页
                path: 'home',
                name: 'home',
                component: () => import('@/views/home/index'),
                meta: {
                    title: 'home',
                    icon: 'home',
                    affix: true //当前tag会被固定在 tags-view中（不可被删除）
                },
            },
            {
                //修改管理员密码
                path: 'changePassword',
                name: 'changePassword',
                component: () => import('@/views/home/changePassword'),
                meta: {
                    title: 'changePassword',
                    icon: 'changePassword',
                },
                hidden: true
            }]
    },
]

export const asyncRouterMap = [
    {path: '*', redirect: '/404', hidden: true}, //放上面加入异步路由，就会导致刷新404，放尾部就解决了
    {
        //商品管理
        path: '/pms',
        component: Layout,
        redirect: '/pms/product',
        name: 'pms',
        meta: {title: 'pms', icon: 'product'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [{
            //商品列表
            path: 'product',
            name: 'product',
            component: () => import('@/views/pms/product/index'),
            meta: {
                title: 'product',
                icon: 'list',
                noCache: true
            }
        },
            {
                //添加商品
                path: 'addProduct',
                name: 'addProduct',
                component: () => import('@/views/pms/product/add'),
                meta: {title: 'addProduct', icon: 'add'}
            },
            {
                //修改商品
                path: 'updateProduct',
                name: 'updateProduct',
                component: () => import('@/views/pms/product/update'),
                meta: {
                    title: 'updateProduct',
                    icon: 'add',
                    noCache: true
                },
                hidden: true
            },
            // {
            //   //商品回收站
            //   path: 'productRecycle',
            //   name: 'productRecycle',
            //   component: () => import('@/views/pms/product/index'),
            //   meta: {title: 'productRecycle', icon: 'product-recycle'},
            //   hidden: true
            // },
            {
                //商品分类
                path: 'productCate',
                name: 'productCate',
                component: () => import('@/views/pms/productCate/index'),
                meta: {
                    title: 'productCate',
                    icon: 'product-cate',
                    noCache: true
                }
            },
            {
                //添加商品分类
                path: 'addProductCate',
                name: 'addProductCate',
                component: () => import('@/views/pms/productCate/add'),
                meta: {
                    title: 'addProductCate',
                    noCache: true
                },
                hidden: true
            },
            {
                //修改商品分类
                path: 'updateProductCate',
                name: 'updateProductCate',
                component: () => import('@/views/pms/productCate/update'),
                meta: {
                    title: 'updateProductCate',
                    noCache: true
                },
                hidden: true
            },
            {
                //商品类型
                path: 'productAttr',
                name: 'productAttr',
                component: () => import('@/views/pms/productAttr/index'),
                meta: {title: 'productAttr', icon: 'product-attr'}
            },
            {
                //商品规格属性列表
                path: 'productSpecList',
                name: 'productSpecList',
                component: () => import('@/views/pms/productAttr/productSpecList'),
                meta: {
                    title: 'productSpecList',
                    noCache: true
                },
                hidden: true
            },
            {
                //商品参数属性列表
                path: 'productParamList',
                name: 'productParamList',
                component: () => import('@/views/pms/productAttr/productParamList'),
                meta: {
                    title: 'productParamList',
                    noCache: true
                },
                hidden: true
            },
            {
                //添加商品属性
                path: 'addProductAttr',
                name: 'addProductAttr',
                component: () => import('@/views/pms/productAttr/addProductAttr'),
                meta: {title: 'addProductAttr'},
                hidden: true
            },
            {
                //修改商品属性
                path: 'updateProductAttr',
                name: 'updateProductAttr',
                component: () => import('@/views/pms/productAttr/updateProductAttr'),
                meta: {title: 'updateProductAttr'},
                hidden: true
            },
            {
                //品牌管理
                path: 'brand',
                name: 'brand',
                component: () => import('@/views/pms/brand/index'),
                meta: {
                    title: 'brand',
                    icon: 'product-brand',
                    noCache: true
                }
            },
            {
                //添加品牌
                path: 'addBrand',
                name: 'addBrand',
                component: () => import('@/views/pms/brand/add'),
                meta: {title: 'addBrand'},
                hidden: true
            },
            {
                //编辑品牌
                path: 'updateBrand',
                name: 'updateBrand',
                component: () => import('@/views/pms/brand/update'),
                meta: {
                    title: 'updateBrand',
                    noCache: true
                },
                hidden: true,
            },
            {
                //商品评价
                path: 'productComment',
                name: 'productComment',
                component: () => import('@/views/pms/comment/index'),
                meta: {title: 'productComment', icon: 'product-comment'},
            },
            {
                //商品评价
                path: 'commentDetail',
                name: 'commentDetail',
                component: () => import('@/views/pms/comment/commentDetail'),
                meta: {title: 'commentDetail', icon: ''},
                hidden: true
            },
            {
                //数据队列
                path: 'dataCaptureQueue',
                name: 'dataCaptureQueue',
                component: () => import('@/views/sys/data/dataList'),
                meta: {
                    title: 'dataCaptureQueue',
                    noCache: true
                },
            }
        ]
    },
    {
        //会员管理
        path: '/crm',
        component: Layout,
        redirect: '/crm/member',
        name: 'crm',
        meta: {title: 'crm', icon: 'member'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //会员列表
                path: 'member',
                name: 'member',
                component: () => import('@/views/crm/member/index'),
                meta: {
                    title: 'member',
                    icon: 'list',
                    noCache: true
                }
            },
            /*{
              //查看会员
              path: 'memberDetail',
              name: 'memberDetail',
              component: () => import('@/views/crm/member/member'),
              meta: {
                title: 'memberDetail',
                icon: 'member-level',
                noCache: true
              },
              hidden: true
            },*/
            {
                //编辑会员
                path: 'updateMember',
                name: 'updateMember',
                component: () => import('@/views/crm/member/update'),
                meta: {
                    title: 'updateMember',
                    icon: '',
                    noCache: true
                },
                hidden: true
            },
            {
                //会员等级
                path: 'memberLevel',
                name: 'memberLevel',
                component: () => import('@/views/crm/memberLevel/index'),
                meta: {
                    title: 'memberLevel',
                    icon: 'member-level',
                    noCache: true
                }
            },
            {
                //积分规则
                path: 'integral',
                name: 'integral',
                component: () => import('@/views/crm/integral/setting'),
                meta: {
                    title: 'integral',
                    icon: 'integral',
                    noCache: true
                }
            },
        ]
    },
    {
        //订单管理
        path: '/oms',
        component: Layout,
        redirect: '/oms/order',
        name: 'oms',
        meta: {title: 'oms', icon: 'order'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //订单列表
                path: 'order',
                name: 'order',
                component: () => import('@/views/oms/order/index'),
                meta: {
                    title: 'order',
                    icon: 'list',
                    noCache: true
                }
            },
            {
                //订单详情
                path: 'orderDetail',
                name: 'orderDetail',
                component: () => import('@/views/oms/order/orderDetail'),
                meta: {
                    title: 'orderDetail',
                    noCache: true
                },
                hidden: true
            },
            {
                //发货列表
                path: 'deliverOrderList',
                name: 'deliverOrderList',
                component: () => import('@/views/oms/order/deliverOrderList'),
                meta: {
                    title: 'deliverOrderList',
                    noCache: true
                },
                hidden: true
            },
            {
                //订单设置
                path: 'orderSetting',
                name: 'orderSetting',
                component: () => import('@/views/oms/order/setting'),
                meta: {title: 'orderSetting', icon: 'order-setting'}
            },
            {
                //退货申请处理
                path: 'returnApply',
                name: 'returnApply',
                component: () => import('@/views/oms/apply/index'),
                meta: {title: 'returnApply', icon: 'order-return'}
            },
            {
                //退货原因设置
                path: 'returnReason',
                name: 'returnReason',
                component: () => import('@/views/oms/apply/reason'),
                meta: {title: 'returnReason', icon: 'order-return-reason'}
            },
            {
                //退货原因详情
                path: 'returnApplyDetail',
                name: 'returnApplyDetail',
                component: () => import('@/views/oms/apply/applyDetail'),
                meta: {title: 'returnApplyDetail'},
                hidden: true
            }
        ]
    },
    {
        //营销管理
        path: '/sms',
        component: Layout,
        redirect: '/sms/advertise',
        name: 'sms',
        meta: {title: 'sms', icon: 'sms'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            /*{
                path: 'flash',
                name: 'flash',
                component: () => import('@/views/sms/flash/index'),
                meta: {
                    title: '秒杀活动列表',
                    icon: 'sms-flash',
                    noCache: true
                }
            },
            {
                path: 'flashSession',
                name: 'flashSession',
                component: () => import('@/views/sms/flash/sessionList'),
                meta: {
                    title: '秒杀时间段列表',
                    noCache: true
                },
                hidden: true
            },
            {
                path: 'selectSession',
                name: 'selectSession',
                component: () => import('@/views/sms/flash/selectSessionList'),
                meta: {title: '秒杀时间段选择'},
                hidden: true
            },
            {
                path: 'flashProductRelation',
                name: 'flashProductRelation',
                component: () => import('@/views/sms/flash/productRelationList'),
                meta: {
                    title: '秒杀商品列表',
                    noCache: true
                },
                hidden: true
            },
            {
                path: 'coupon',
                name: 'coupon',
                component: () => import('@/views/sms/coupon/index'),
                meta: {
                    title: '优惠券列表',
                    icon: 'sms-coupon',
                    noCache: true
                }
            },
            {
                path: 'addCoupon',
                name: 'addCoupon',
                component: () => import('@/views/sms/coupon/add'),
                meta: {title: '添加优惠券'},
                hidden: true
            },
            {
                path: 'updateCoupon',
                name: 'updateCoupon',
                component: () => import('@/views/sms/coupon/update'),
                meta: {title: '修改优惠券'},
                hidden: true
            },
            {
                path: 'couponHistory',
                name: 'couponHistory',
                component: () => import('@/views/sms/coupon/history'),
                meta: {title: '优惠券领取详情'},
                hidden: true
            },
            {
                path: 'brand',
                name: 'homeBrand',
                component: () => import('@/views/sms/brand/index'),
                meta: {title: '品牌推荐', icon: 'product-brand'}
            },
            {
                path: 'new',
                name: 'homeNew',
                component: () => import('@/views/sms/new/index'),
                meta: {title: '新品推荐', icon: 'sms-new'}
            },
            {
                path: 'hot',
                name: 'homeHot',
                component: () => import('@/views/sms/hot/index'),
                meta: {title: '人气推荐', icon: 'sms-hot'}
            },
            {
                path: 'subject',
                name: 'homeSubject',
                component: () => import('@/views/sms/subject/index'),
                meta: {title: '专题推荐', icon: 'sms-subject'}
            },*/
            {
                //广告列表
                path: 'advertise',
                name: 'homeAdvertise',
                component: () => import('@/views/sms/advertise/index'),
                meta: {
                    title: 'advertise',
                    icon: 'sms-ad',
                    noCache: true
                }
            },
            {
                //添加广告
                path: 'addAdvertise',
                name: 'addHomeAdvertise',
                component: () => import('@/views/sms/advertise/add'),
                meta: {title: 'addAdvertise'},
                hidden: true
            },
            {
                //编辑广告
                path: 'updateAdvertise',
                name: 'updateHomeAdvertise',
                component: () => import('@/views/sms/advertise/update'),
                meta: {title: 'updateAdvertise'},
                hidden: true
            },
            {
                //商品主题列表
                path: 'productSubject',
                name: 'productSubject',
                component: () => import('@/views/sms/productSubject/index'),
                meta: {
                    title: 'productSubject',
                    icon: 'tuijian',
                    noCache: true
                }
            },
        ]
    },
    {
        //商家管理
        path: '/mms',
        component: Layout,
        redirect: '/mms/shop/',
        name: 'mms',
        meta: {title: 'mms', icon: 'shop'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //商家列表
                path: 'shop',
                name: 'shop',
                component: () => import('@/views/mms/shop/index'),
                meta: {
                    title: 'shop',
                    icon: 'list',
                    noCache: true
                }
            },
            {
                //新增商家
                path: 'addShop',
                name: 'addShop',
                component: () => import('@/views/mms/shop/add'),
                meta: {
                    title: 'addShop',
                    icon: 'add',
                }
            },
            {
                //修改商家
                path: 'updateShop',
                name: 'updateShop',
                component: () => import('@/views/mms/shop/update'),
                meta: {
                    title: 'updateShop',
                    icon: '',
                    noCache: true
                },
                hidden: true
            },
            {
                //店铺结算列表
                path: 'clearing',
                name: 'clearing',
                component: () => import('@/views/mms/clearing/index'),
                meta: {title: 'clearing', icon: 'withdraw', noCache: true},
            },
            {
                //区域管理列表
                path: 'belongZone',
                name: 'belongZone',
                component: () => import('@/views/mms/belongZone/index'),
                meta: {title: 'belongZone', icon: 'list', noCache: true},
            },
            {
                //在线聊天列表
                path: 'customerService',
                name: 'customerService',
                component: () => import('@/views/ims/chat/index'),
                meta: {title: 'customerService', icon: 'customerService', noCache: true},
            }
        ]
    },
    {
        //资讯文章
        path: '/cms',
        component: Layout,
        redirect: '/cms/article/list',
        name: 'cms',
        meta: {title: 'cms', icon: 'article_icon'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //文章列表
                path: 'article',
                name: 'article',
                component: () => import('@/views/cms/article/index'),
                meta: {
                    title: 'article',
                    icon: 'list',
                    noCache: true
                }
            },
            {
                //文章审核列表
                path: 'articleApproved',
                name: 'articleApproved',
                component: () => import('@/views/cms/article/approvedList'),
                meta: {
                    title: 'articleApproved',
                    icon: 'list',
                    noCache: true
                }
            },
            {
                //新增文章
                path: 'addArticle',
                name: 'addArticle',
                component: () => import('@/views/cms/article/add'),
                meta: {title: 'addArticle', icon: 'add'},
                // hidden: true
            },
            {
                //编辑文章
                path: 'updateArticle',
                name: 'updateArticle',
                component: () => import('@/views/cms/article/update'),
                meta: {title: 'updateArticle', icon: ''},
                hidden: true
            }
        ]
    },
    {
        //系统配置
        path: '/sys',
        component: Layout,
        redirect: '/sys/params',
        name: 'sys',
        meta: {title: 'sys', icon: 'sys-icon'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //系统参数
                path: 'params',
                name: 'params',
                component: () => import('@/views/sys/params/index'),
                meta: {
                    title: 'params',
                    icon: 'params',
                    noCache: true
                }
            },
            {
                //汇率设置
                path: 'exchangeRate',
                name: 'exchangeRate',
                component: () => import('@/views/sys/exchangeRate/index'),
                meta: {title: 'exchangeRate', icon: 'exchangeRate'},
            },
            {
                //员工列表
                path: 'admin',
                name: 'admin',
                component: () => import('@/views/sys/admin/index'),
                meta: {
                    title: 'employeesList',
                    icon: 'ums-admin',
                    noCache: true
                }
            },
            {
                //角色列表
                path: 'role',
                name: 'role',
                component: () => import('@/views/sys/role/index'),
                meta: {
                    title: 'roleList',
                    icon: 'ums-role',
                    noCache: true
                }
            },
            {
                //分配菜单
                path: 'allocMenu',
                name: 'allocMenu',
                component: () => import('@/views/sys/role/allocMenu'),
                meta: {
                    title: 'allocMenu',
                    noCache: true
                },
                hidden: true
            },
            {
                //分配资源
                path: 'allocResource',
                name: 'allocResource',
                component: () => import('@/views/sys/role/allocResource'),
                meta: {
                    title: 'allocResource',
                    noCache: true
                },
                hidden: true
            },
            {
                //菜单列表
                path: 'menu',
                name: 'menu',
                component: () => import('@/views/sys/menu/index'),
                meta: {
                    title: 'menuList',
                    icon: 'ums-menu',
                    noCache: true
                }
            },
            {
                //添加菜单
                path: 'addMenu',
                name: 'addMenu',
                component: () => import('@/views/sys/menu/add'),
                meta: {
                    title: 'addMenu',
                    noCache: true
                },
                hidden: true
            },
            {
                //修改菜单
                path: 'updateMenu',
                name: 'updateMenu',
                component: () => import('@/views/sys/menu/update'),
                meta: {
                    title: 'updateMenu',
                    noCache: true
                },
                hidden: true
            },
            {
                //资源列表
                path: 'resource',
                name: 'resource',
                component: () => import('@/views/sys/resource/index'),
                meta: {
                    title: 'resourceList',
                    icon: 'ums-resource',
                    noCache: true
                }
            },
            {
                //资源分类
                path: 'resourceCategory',
                name: 'resourceCategory',
                component: () => import('@/views/sys/resource/categoryList'),
                meta: {
                    title: 'resourceCategory',
                    noCache: true
                },
                hidden: true
            },
            {
                //软件升级列表
                path: 'appUpdateList',
                name: 'appUpdateList',
                component: () => import('@/views/sys/update/index'),
                meta: {
                    title: 'appUpdateList',
                    icon: 'app-update',
                    noCache: true
                }
            },
        ]
    },
    {
        //物流管理
        path: '/lms',
        component: Layout,
        redirect: '/lms/deliveryWay/index',
        name: 'lms',
        meta: {title: 'lms', icon: 'wuliu'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //物流公司列表
                path: 'logisticsCompany',
                name: 'logisticsCompany',
                component: () => import('@/views/lms/logisticsCompany/index'),
                meta: {
                    title: 'logisticsCompany',
                    icon: 'wlgs',
                    noCache: true
                }
            },
            {
                //配送方式列表
                path: 'deliveryWay',
                name: 'deliveryWay',
                component: () => import('@/views/lms/deliveryWay/index'),
                meta: {
                    title: 'deliveryWay',
                    icon: 'psfs',
                    noCache: true
                }
            },
            {
                //配送规则列表
                path: 'deliveryRule',
                name: 'deliveryRule',
                component: () => import('@/views/lms/deliveryWay/deliveryRuleList'),
                meta: {
                    title: 'deliveryRule',
                    icon: 'psgz',
                    noCache: true
                },
                hidden: true
            },
            {
                //配送附加规则列表
                path: 'deliveryAdditionalRule',
                name: 'deliveryAdditionalRule',
                component: () => import('@/views/lms/deliveryWay/deliveryAdditionalRuleList'),
                meta: {
                    title: 'deliveryAdditionalRule',
                    icon: 'fjpsgz',
                    noCache: true
                },
                hidden: true
            },
            {
                //仓库管理列表
                path: 'depot',
                name: 'depot',
                component: () => import('@/views/lms/depot/index'),
                meta: {
                    title: 'depot',
                    icon: 'depot',
                    noCache: true
                },
            },
            {
                //仓库管理列表
                path: 'depotGoods',
                name: 'depotGoods',
                component: () => import('@/views/lms/depot/depotGoodsList'),
                meta: {
                    title: 'depotGoods',
                    icon: 'depotGoods',
                    noCache: true
                },
            },
        ]
    },
    {
        //统计报表
        path: '/chart',
        component: Layout,
        redirect: '/chart/memberStatement/index',
        name: 'chart',
        meta: {title: 'chart', icon: 'chart'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //会员统计报表
                path: 'memberStatement',
                name: 'memberStatement',
                component: () => import('@/views/chart/memberStatement/index'),
                meta: {
                    title: 'memberStatement',
                    icon: 'member-chart',
                    noCache: true
                }
            },
            {
                //订单统计报表
                path: 'orderStatement',
                name: 'orderStatement',
                component: () => import('@/views/chart/orderStatement/index'),
                meta: {
                    title: 'orderStatement',
                    icon: 'order-chart',
                    noCache: true
                }
            },
        ]
    },
    {
        //视频
        path: '/vms',
        component: Layout,
        redirect: '/vms/video/index',
        name: 'vms',
        meta: {title: 'vms', icon: 'vms'},
        alwaysShow: true, // 当子菜单只有一个的时候，还是显示层级
        children: [
            {
                //视频管理
                path: 'video',
                name: 'video',
                component: () => import('@/views/vms/video/index'),
                meta: {
                    title: 'video',
                    icon: 'video',
                    noCache: true
                }
            },
            {
                //视频标签管理
                path: 'videoTag',
                name: 'videoTag',
                component: () => import('@/views/vms/videoTag/index'),
                meta: {
                    title: 'videoTag',
                    icon: 'video-tag',
                    noCache: true
                }
            },
            {
                //添加视频标签
                path: 'addVideoTag',
                name: 'addVideoTag',
                component: () => import('@/views/vms/videoTag/add'),
                meta: {title: 'addVideoTag'},
                hidden: true
            },
            {
                //编辑视频标签
                path: 'updateVideoTag',
                name: 'updateVideoTag',
                component: () => import('@/views/vms/videoTag/update'),
                meta: {
                    title: 'updateVideoTag',
                    noCache: true
                },
                hidden: true,
            },
            {
                //直播计划管理
                path: 'videoLivePlan',
                name: 'videoLivePlan',
                component: () => import('@/views/vms/livePlan/index'),
                meta: {
                    title: 'videoLivePlan',
                    icon: 'video-live-plan',
                    noCache: true
                }
            },
            {
                //添加直播计划
                path: 'addVideoLivePlan',
                name: 'addVideoLivePlan',
                component: () => import('@/views/vms/livePlan/add'),
                meta: {title: 'addVideoLivePlan'},
                hidden: true
            },
            {
                //编辑直播计划
                path: 'updateVideoLivePlan',
                name: 'updateVideoLivePlan',
                component: () => import('@/views/vms/livePlan/update'),
                meta: {
                    title: 'updateVideoLivePlan',
                    noCache: true
                },
                hidden: true,
            },
            {
                //直播会员认证管理
                path: 'videoLiveMemberAuth',
                name: 'videoLiveMemberAuth',
                component: () => import('@/views/vms/liveMemberAuth/index'),
                meta: {
                    title: 'videoLiveMemberAuth',
                    icon: 'video-live-member-auth',
                    noCache: true
                }
            },
            {
                //直播配置管理
                path: 'liveSetting',
                name: 'liveSetting',
                component: () => import('@/views/vms/setting/liveSetting'),
                meta: {
                    title: 'liveSetting',
                    icon: 'live-setting',
                    noCache: true
                }
            },
            {
                //视频评论管理
                path: 'videoComment',
                name: 'videoComment',
                component: () => import('@/views/vms/comment/index'),
                meta: {
                    title: 'videoComment',
                    icon: 'video-comment',
                    noCache: true
                }
            },
            {
                //抖音视频队列
                path: 'douyinVideoQueue',
                name: 'douyinVideoQueue',
                component: () => import('@/views/vms/douyinVideo/index'),
                meta: {
                    title: 'douyinVideoQueue',
                    noCache: true
                },
            }
        ]
    },
    // {
    //   //权限管理
    //   path: 'permission',
    //   name: 'permission',
    //   component: Layout,
    //   redirect: '/sys/permission',
    //   meta: {
    //     title: 'permission',
    //     icon: 'permission',
    //   },
    //   children: [
    //
    //   ]
    // }
]

/*export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})*/

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js